



import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";
import BannerOne from "../share/component.jsx/banner";


const SERVICES = [
  {
    id: 1,
    num: "01",
    image: require('../assets/services/Clinical Research Consultancy.jpg'),
    title: "Clinical Research Consultancy",
    desc: "Our Clinical Research Consultancy support includes clinical trial design, protocol writing, ethics submissions, and regulatory planning. We assist researchers in constructing robust Phase I-IV study frameworks with well-defined goals and quantifiable outcomes. We also inform patients about selection, study endpoints, methodology of data collection, and compliance requirements.",
    tags: ["Trial Design", "Protocol", "Regulatory"],
  },
  {
    id: 2,
    num: "02",
    image: require('../assets/services/Cardiovascular Research.jpg'),
    title: "Cardiovascular Research",
    desc: "Our Cardiovascular research centers on interventional cardiology, cardiac imaging, heart failure, electrophysiology, and outcomes-based research. We assist researchers in formulating meaningful questions, powerful methods, and viable study designs. We support registry studies, clinical audits, retrospective studies, and multicenter collaborations.",
    tags: ["Cardiology", "Imaging", "Outcomes"],
  },
  {
    id: 3,
    num: "03",
    image: require('../assets/services/Biostatistics & Data Analysis.jpg'),
    title: "Biostatistics & Data Analysis",
    desc: "Our biostatistics team offers advanced sample size calculation, statistical modeling, survival analysis, regression analysis, and subgroup comparisons. We assist in transforming raw medical data into accurate, dependable, and publication-quality results. We write tables, graphs, and visual summaries for peer-reviewed journals.",
    tags: ["Statistics", "Modeling", "Visuals"],
  },
  {
    id: 4,
    num: "04",
    image: require('../assets/services/China Academic Research Consulting.jpg'),
    title: "China Academic Research Consulting",
    desc: "Our Medical academic research consulting China service supports Chinese doctors, hospitals, researchers, and academic teams aiming for international publication. We steer SCI paper planning, journal pick, manuscript structure, and global submission guidelines. We contribute to bridging the gap between Chinese academic institutions and international journals.",
    tags: ["China", "SCI", "Global"],
  },
  {
    id: 5,
    num: "05",
    image: require('../assets/services/Medical Writing & Publication.jpg'),
    title: "Medical Writing & Publication",
    desc: "Scientific manuscripts, systematic reviews, meta-analyses, abstracts, case reports, and grant proposals are all found in our medical writing service. We are well structured, highly evidenced, and journal-oriented. We help with cover letters, reviewer responses, revisions, and resubmissions.",
    tags: ["Manuscripts", "Publishing", "Grants"],
  },
  {
    id: 6,
    num: "06",
    image: require('../assets/services/Research Methodology Consulting.jpg'),
    title: "Research Methodology Consulting",
    desc: "Our methodology consulting aids researchers in selecting the correct study design to answer their question. We endorse randomized controlled trials, cohort studies, case-control studies, cross-sectional research, and translational research models. We refine objectives, inclusion criteria, endpoints, and data collection plans.",
    tags: ["Design", "Endpoints", "Ethics"],
  },
];



const PROCESS = [
  { step: "01", title: "Discovery Call", desc: "We start with a guided discovery call to learn about your research objectives, data at hand, target journal, schedule, and anticipated results. We discuss existing issues, gaps in research, and potential directions of the study. We recommend an optimal consultation route towards your academic objectives." },
  { step: "02", title: "Strategy Design", desc: "Our specialists develop a tailor-made research roadmap after the discovery call. This involves methodology, schedules, resource scheduling, data requirements, analysis plan, and publication objectives. We assist in defining the study question, research design, and the writing plan." },
  { step: "03", title: "Active Consultation", desc: "We take your team through the data collection, data analysis, manuscript writing, peer review, and revision processes during active consultation. Our professionals are engaged throughout each significant phase. We assist in addressing research design issues, statistical questions, and journal response issues." },
  { step: "04", title: "Publication & Impact", desc: "We direct your research to high-impact journals, conferences, grants, and academic visibility. Our services include journal formatting, planning to submit, and preparing responses to reviewers. We aim not just at being published but at achieving long-term academic potential." },
];



const ServiceCard = ({ s, i }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        // background: hov ? "#0a2540" : "#fff",
         border: hov ? "1.5px solid #2acb35" : "1.5px solid #e8eef4",
        borderRadius: 18,
        padding: "36px 30px 30px",
        transition: "all 0.35s cubic-bezier(.22,.68,0,1.15)",
        transform: hov ? "translateY(-6px)" : "translateY(0)",
        boxShadow: hov ? "0 20px 52px rgba(10,37,64,0.22)" : "0 2px 16px rgba(0,0,0,0.05)",
        cursor: "default",
        display: "flex",
        flexDirection: "column",
        gap: 0,
        animationDelay: `${i * 0.08}s`,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s", marginBottom: 15 }}>
          {s.image ? (
            <img src={s.image} alt={s.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{s.icon}</span>
          )}
        </div>
        <span style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 36,
          color: hov ? "rgba(26,111,175,0.35)" : "#dbeaf5",
          lineHeight: 1,
          letterSpacing: "0.02em",
          transition: "color 0.3s",
        }}>{s.num}</span>
      </div>
      <h3 style={{
        fontFamily: "'Libre Baskerville', Georgia, serif",
        fontSize: 18,
        fontWeight: 700,
        color: "#0a2540",
        margin: "0 0 12px",
        lineHeight: 1.3,
        letterSpacing: "-0.01em",
        transition: "color 0.3s",
      }}>{s.title}</h3>
      <p style={{
        fontSize: 13.5,
        color:  "#5a7184",
        lineHeight: 1.75,
        fontFamily: "'Source Serif 4', Georgia, serif",
        margin: "0 0 20px",
        flexGrow: 1,
        transition: "color 0.3s",
      }}>{s.desc}</p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {s.tags.map(t => (
          <span key={t} style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.07em",
            textTransform: "uppercase",
            padding: "4px 10px",
            borderRadius: 20,
            background:  "#eaf3fb",
            color:  "#2acb35",
            transition: "all 0.3s",
          }}>{t}</span>
        ))}
      </div>
    </div>
  );
};

const ProcessStep = ({ p, i, total }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        position: "relative",
        flex: 1,
        minWidth: 180,
        transition: "transform 0.25s",
        transform: hov ? "translateY(-4px)" : "translateY(0)",
      }}
    >
      {/* connector line */}
      {i < total - 1 && (
        <div style={{
          position: "absolute",
          top: 28,
          left: "calc(72px)",
          right: "-28px",
          height: 1.5,
          background: "linear-gradient(90deg, #1a6faf44, transparent)",
          zIndex: 0,
        }} />
      )}
      <div style={{
        width: 56, height: 56,
        borderRadius: 14,
        background: hov ? "linear-gradient(135deg,#1a6faf,#0a2540)" : "#eaf3fb",
        display: "flex", alignItems: "center", justifyContent: "center",
        marginBottom: 20,
        zIndex: 1,
        boxShadow: hov ? "0 8px 24px rgba(26,111,175,0.3)" : "none",
        transition: "all 0.3s",
      }}>
        <span style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 22,
          color: hov ? "#fff" : "#2acb35",
          letterSpacing: "0.04em",
          transition: "color 0.3s",
        }}>{p.step}</span>
      </div>
      <h4 style={{
        fontFamily: "'Libre Baskerville', serif",
        fontSize: 16,
        fontWeight: 700,
        color: "#0a2540",
        margin: "0 0 8px",
      }}>{p.title}</h4>
      <p style={{
        fontSize: 13,
        color: "#5a7184",
        lineHeight: 1.7,
        fontFamily: "'Source Serif 4', serif",
        margin: 0,
      }}>{p.desc}</p>
    </div>
  );
};

/* ─── MAIN ──────────────────────────────────────────── */
export default function MedicalAcademicConsultation() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <style>{`
       
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --navy: #102712;
          --blue: #2acb35;
          --sky: #eaf8ef;
          --teal: #58c87b;
          --sand: #ffff;
          --ink: #243827;
          --muted: #506c56;
        }

        .mrc-root {
          font-family: 'Hind', sans-serif;
          background: #fff;
          color: var(--navy);
          min-height: 100vh;
          overflow-x: hidden;
        }

        /* ── NAV ── */
        .mrc-nav {
          position: sticky; top: 0; z-index: 100;
          background: rgba(10,37,64,0.97);
          backdrop-filter: blur(16px);
          padding: 0 52px;
          display: flex; align-items: center; justify-content: space-between;
          height: 70px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .mrc-logo {
          display: flex; align-items: center; gap: 12px;
          text-decoration: none;
        }
        .mrc-logo-mark {
          width: 40px; height: 40px; border-radius: 10px;
          background: linear-gradient(135deg, var(--blue), var(--teal));
          display: flex; align-items: center; justify-content: center;
          font-size: 20px;
        }
        .mrc-logo-name {
          font-family: 'Libre Baskerville', serif;
          font-size: 17px; font-weight: 700;
          color: #fff; letter-spacing: -0.01em;
          line-height: 1.2;
        }
        .mrc-logo-sub {
          display: block;
          font-size: 9px; font-weight: 400;
          color: rgba(255,255,255,0.45);
          letter-spacing: 0.14em;
          text-transform: uppercase;
          font-family: 'Hind', sans-serif;
        }
        .mrc-nav-links {
          display: flex; gap: 30px; list-style: none;
        }
        .mrc-nav-links a {
          text-decoration: none;
          font-size: 13.5px; font-weight: 500;
          color: rgba(255,255,255,0.6);
          transition: color 0.2s; letter-spacing: 0.01em;
        }
        .mrc-nav-links a:hover { color: #fff; }
        .mrc-nav-right { display: flex; gap: 12px; align-items: center; }
        .mrc-btn-ghost {
          background: rgba(255,255,255,0.07);
          color: rgba(255,255,255,0.8);
          border: 1px solid rgba(255,255,255,0.15);
          padding: 9px 20px; border-radius: 30px;
          font-size: 13px; font-weight: 600;
          cursor: pointer; font-family: 'Hind', sans-serif;
          transition: all 0.2s;
        }
        .mrc-btn-ghost:hover { background: rgba(255,255,255,0.14); }
        .mrc-btn-accent {
          background: linear-gradient(135deg, var(--blue), var(--teal));
          color: #fff; border: none;
          padding: 10px 22px; border-radius: 30px;
          font-size: 13px; font-weight: 700;
          cursor: pointer; font-family: 'Hind', sans-serif;
          transition: all 0.2s;
          box-shadow: 0 4px 16px rgba(14,159,142,0.3);
        }
        .mrc-btn-accent:hover { opacity: 0.9; transform: translateY(-1px); }
        .mrc-hamburger {
          display: none; background: none; border: none;
          color: #fff; font-size: 22px; cursor: pointer;
        }

        /* ── HERO ── */
        .mrc-hero {
          background: var(--navy);
          position: relative; overflow: hidden;
          padding: 110px 52px 90px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          min-height: 90vh;
        }
        .mrc-hero::before {
          content: '';
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 55% 70% at 100% 60%, rgba(26,111,175,0.22) 0%, transparent 65%),
            radial-gradient(ellipse 35% 50% at 0% 30%, rgba(14,159,142,0.12) 0%, transparent 60%);
          pointer-events: none;
        }
        .mrc-hero-dots {
          position: absolute; inset: 0;
          background-image: radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 28px 28px;
          pointer-events: none;
        }
        .mrc-hero-left { position: relative; z-index: 2; }
        .mrc-hero-right { position: relative; z-index: 2; }

        .mrc-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(26,111,175,0.15);
          border: 1px solid rgba(26,111,175,0.4);
          color: #7ec8f4;
          font-size: 11px; font-weight: 700;
          letter-spacing: 0.12em; text-transform: uppercase;
          padding: 6px 14px; border-radius: 30px; margin-bottom: 28px;
        }
        .mrc-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--teal); animation: blink 1.6s ease infinite; }
        @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.3} }

        .mrc-hero-h1 {
          font-family: 'Libre Baskerville', Georgia, serif;
          font-size: clamp(32px, 4.5vw, 60px);
          font-weight: 700;
          color: #fff;
          line-height: 1.12;
          letter-spacing: -0.025em;
          margin-bottom: 24px;
        }
        .mrc-hero-h1 .accent {
          font-style: italic;
          color: transparent;
          background: linear-gradient(90deg, #7ec8f4, var(--teal));
          -webkit-background-clip: text;
          background-clip: text;
        }
        .mrc-hero-sub {
          font-size: 16px; line-height: 1.8;
          color: rgba(255,255,255,0.62);
          font-family: 'Source Serif 4', serif;
          margin-bottom: 36px;
          max-width: 480px;
        }
        .mrc-hero-btns {
          display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 48px;
        }
        .mrc-btn-primary {
          background: linear-gradient(135deg, var(--blue), var(--teal));
          color: #fff; border: none;
          padding: 15px 32px; border-radius: 40px;
          font-size: 14px; font-weight: 700;
          cursor: pointer; font-family: 'Hind', sans-serif;
          box-shadow: 0 8px 28px rgba(14,159,142,0.35);
          transition: all 0.25s; letter-spacing: 0.02em;
        }
        .mrc-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(14,159,142,0.45); }
        .mrc-btn-outline-hero {
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.85);
          border: 1.5px solid rgba(255,255,255,0.2);
          padding: 15px 32px; border-radius: 40px;
          font-size: 14px; font-weight: 600;
          cursor: pointer; font-family: 'Hind', sans-serif;
          transition: all 0.25s;
        }
        .mrc-btn-outline-hero:hover { background: rgba(255,255,255,0.12); }
        .mrc-kw-strip {
          display: flex; gap: 8px; flex-wrap: wrap;
        }
        .mrc-kw-pill {
          font-size: 11px; font-weight: 600; letter-spacing: 0.06em;
          text-transform: uppercase;
          padding: 5px 12px; border-radius: 20px;
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.45);
          border: 1px solid rgba(255,255,255,0.1);
        }

        /* Hero right panel */
        .mrc-hero-panel {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 24px;
          padding: 36px;
          backdrop-filter: blur(8px);
        }
        .mrc-hero-panel-title {
          font-family: 'Bebas Neue', sans-serif;
          font-size: 13px; letter-spacing: 0.18em;
          color: rgba(255,255,255,0.35);
          text-transform: uppercase;
          margin-bottom: 24px;
        }
        .mrc-expertise-list { display: flex; flex-direction: column; gap: 16px; }
        .mrc-expertise-item {
          display: flex; align-items: center; gap: 14px;
          padding: 14px 16px;
          border-radius: 12px;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          transition: all 0.22s;
          cursor: default;
        }
        .mrc-expertise-item:hover {
          background: rgba(26,111,175,0.15);
          border-color: rgba(26,111,175,0.35);
        }
        .mrc-expertise-icon {
          font-size: 22px; width: 40px; text-align: center;
        }
        .mrc-expertise-label {
          font-size: 14px; font-weight: 600; color: rgba(255,255,255,0.85);
          font-family: 'Hind', sans-serif;
        }
        .mrc-expertise-sub {
          font-size: 12px; color: rgba(255,255,255,0.38);
          font-family: 'Source Serif 4', serif;
        }
        .mrc-expertise-arrow {
          margin-left: auto;
          color: rgba(255,255,255,0.2);
          font-size: 16px;
          transition: transform 0.2s, color 0.2s;
        }
        .mrc-expertise-item:hover .mrc-expertise-arrow {
          transform: translateX(3px);
          color: var(--teal);
        }

        /* ── STATS ── */
        .mrc-stats-bar {
          background: linear-gradient(135deg, #0e9f8e 0%, #1a6faf 100%);
          display: flex; justify-content: center;
          flex-wrap: wrap; gap: 0;
          padding: 40px 52px;
        }
        .mrc-stat {
          flex: 1; min-width: 150px;
          text-align: center; padding: 12px 24px;
          position: relative;
        }
        .mrc-stat:not(:last-child)::after {
          content: ''; position: absolute;
          right: 0; top: 15%; height: 70%; width: 1px;
          background: rgba(255,255,255,0.2);
        }
        .mrc-stat-val {
          display: block;
          font-family: 'Bebas Neue', sans-serif;
          font-size: clamp(32px, 4vw, 48px);
          color: #fff; line-height: 1; letter-spacing: 0.02em;
        }
        .mrc-stat-lbl {
          display: block;
          font-size: 11px; font-weight: 700;
          color: rgba(255,255,255,0.7);
          letter-spacing: 0.12em; text-transform: uppercase;
          margin-top: 6px;
        }

        /* ── SERVICES ── */
        .mrc-services {
          background: var(--sand);
          padding: 100px 52px;
        }
        .mrc-services-inner { max-width: 1240px; margin: 0 auto; }
        .mrc-section-eyebrow {
          font-size: 11px; font-weight: 700;
          letter-spacing: 0.2em; text-transform: uppercase;
          color: var(--teal);
          margin-bottom: 10px;
        }
        .mrc-section-h2 {
          font-family: 'Libre Baskerville', serif;
          font-size: clamp(26px, 3.5vw, 44px);
          font-weight: 700; color: var(--navy);
          letter-spacing: -0.02em; line-height: 1.15;
          margin-bottom: 14px;
        }
        .mrc-section-desc {
          font-size: 15.5px; color: var(--muted);
          line-height: 1.8; font-family: 'Source Serif 4', serif;
          max-width: 580px; margin-bottom: 56px;
        }
        .mrc-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 22px;
        }

        /* ── PROCESS ── */
        .mrc-process {
          background: #fff;
          padding: 100px 52px;
        }
        .mrc-process-inner { max-width: 1240px; margin: 0 auto; }
        .mrc-process-steps {
          display: flex; gap: 40px; margin-top: 56px; flex-wrap: wrap;
        }

        /* ── JOURNALS ── */
        .mrc-journals {
          background: var(--navy);
          padding: 60px 52px;
          text-align: center;
          overflow: hidden;
        }
        .mrc-journals-label {
          font-size: 11px; font-weight: 700;
          letter-spacing: 0.2em; text-transform: uppercase;
          color: rgba(255,255,255,0.35); margin-bottom: 28px;
        }
        .mrc-journals-track {
          display: flex; gap: 0; width: max-content;
          animation: scroll-left 22s linear infinite;
        }
        @keyframes scroll-left {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .mrc-journal-pill {
          padding: 10px 28px;
          margin: 0 10px;
          border-radius: 30px;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.1);
          font-family: 'Libre Baskerville', serif;
          font-size: 14px; font-weight: 700;
          color: rgba(255,255,255,0.6);
          white-space: nowrap;
          transition: all 0.2s;
        }
        .mrc-journals-wrapper:hover .mrc-journals-track { animation-play-state: paused; }

        /* ── CTA ── */
        .mrc-cta {
          background: var(--sand);
          padding: 100px 52px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
          max-width: 100%;
        }
        .mrc-cta-left {}
        .mrc-cta-form {
          background: #fff;
          border: 1.5px solid #e8eef4;
          border-radius: 24px;
          padding: 40px;
          box-shadow: 0 8px 40px rgba(10,37,64,0.08);
        }
        .mrc-form-title {
          font-family: 'Libre Baskerville', serif;
          font-size: 20px; font-weight: 700;
          color: var(--navy); margin-bottom: 24px;
        }
        .mrc-form-group { margin-bottom: 16px; }
        .mrc-form-group label {
          display: block;
          font-size: 12px; font-weight: 700;
          color: var(--ink); letter-spacing: 0.06em;
          text-transform: uppercase; margin-bottom: 6px;
        }
        .mrc-form-group input,
        .mrc-form-group select,
        .mrc-form-group textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1.5px solid #e2eaf2;
          border-radius: 10px;
          font-size: 14px;
          color: var(--navy);
          font-family: 'Hind', sans-serif;
          background: #f8fbfd;
          outline: none;
          transition: border-color 0.2s;
        }
        .mrc-form-group input:focus,
        .mrc-form-group select:focus,
        .mrc-form-group textarea:focus { border-color: var(--blue); background: #fff; }
        .mrc-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .mrc-submit {
          width: 100%;
          background: linear-gradient(135deg, var(--blue), var(--teal));
          color: #fff; border: none;
          padding: 15px; border-radius: 12px;
          font-size: 15px; font-weight: 700;
          cursor: pointer; font-family: 'Hind', sans-serif;
          margin-top: 8px;
          box-shadow: 0 6px 24px rgba(14,159,142,0.3);
          transition: all 0.25s; letter-spacing: 0.02em;
        }
        .mrc-submit:hover { opacity: 0.92; transform: translateY(-1px); }

        /* ── FOOTER ── */
        .mrc-footer {
          background: var(--navy);
          border-top: 1px solid rgba(255,255,255,0.06);
          padding: 28px 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap; gap: 14px;
        }
        .mrc-footer p { font-size: 12.5px; color: rgba(255,255,255,0.35); }
        .mrc-footer-kws { display: flex; gap: 8px; flex-wrap: wrap; }
        .mrc-footer-kw {
          font-size: 11px; color: rgba(14,159,142,0.8);
          background: rgba(14,159,142,0.1);
          padding: 3px 10px; border-radius: 20px;
          letter-spacing: 0.03em;
        }

        /* ── RESPONSIVE ── */
        @media (max-width: 1024px) {
          .mrc-hero { grid-template-columns: 1fr; min-height: unset; }
          .mrc-hero-right { display: none; }
          .mrc-cta { grid-template-columns: 1fr; gap: 48px; }
        }
        @media (max-width: 860px) {
          .mrc-nav { padding: 0 24px; }
          .mrc-nav-links, .mrc-nav-right { display: none; }
          .mrc-hamburger { display: block; }
          .mrc-services-grid { grid-template-columns: repeat(2, 1fr); }
          .mrc-process-steps { flex-direction: column; gap: 32px; }
        }
        @media (max-width: 580px) {
          .mrc-hero { padding: 80px 24px 60px; }
          .mrc-stats-bar { padding: 32px 20px; }
          .mrc-stat:not(:last-child)::after { display: none; }
          .mrc-services { padding: 60px 24px; }
          .mrc-services-grid { grid-template-columns: 1fr; }
          .mrc-process { padding: 60px 24px; }
          .mrc-journals { padding: 40px 24px; }
          .mrc-cta { padding: 60px 24px; }
          .mrc-footer { padding: 20px 24px; flex-direction: column; align-items: flex-start; }
          .mrc-form-row { grid-template-columns: 1fr; }
        }
      `}</style>
      <BannerOne
          img={require('../assets/symptoms/medResearch.png')}
          title={"Medical Academic Research Consultation Services"}
          subtitle={""}
        />

      <div className="mrc-root acc-root">
        
        {/* <PosterOne img={aboutbanner} title={"Medical Academic Research Consultation Services"} /> */}


        {/* SERVICES */}
        <section className="mrc-services">
          <div className="mrc-services-inner">
            <p className="mrc-section-eyebrow">What We Offer</p>
            <h2 className="mrc-section-h2">Comprehensive Medical Academic<br />Research Consultation Services</h2>
            <p className="mrc-section-desc">
              We offer full medical research consulting services to physicians, researchers, hospitals, universities, and health care organizations. We support planning of the study, data analysis, writing of the manuscript, selection of the journal, and publication strategy. Our team assists in all projects in terms of clarity, accuracy, and academic strength, throughout the research design to the final submission.
            </p>
            <div className="mrc-services-grid">
              {SERVICES.map((s, i) => <ServiceCard key={s.id} s={s} i={i} />)}
            </div>
          </div>
        </section>

        {/* PROCESS */}
        <section className="mrc-process">
          <div className="mrc-process-inner">
            <p className="mrc-section-eyebrow">How We Work</p>
            <h2 className="mrc-section-h2">A Structured Research<br />Consultation Process</h2>
            <p className="mrc-section-desc">
              Our four-stage model of consultation provides a clear road map from idea to impact on any research project. Whether you require clinical trial planning, statistical support, or publication guidance, we do not complicate the process and make it easy to follow. Every stage is oriented to clarity, quality, and quantifiable improvements.
            </p>
            <div className="mrc-process-steps">
              {PROCESS.map((p, i) => (
                <ProcessStep key={p.step} p={p} i={i} total={PROCESS.length} />
              ))}
            </div>
          </div>
        </section>

       

        <section className="service-cta">
          <div className="service-container">
            <h2>Let's Turn Your Research Idea Into a Published Reality</h2>
            <p> Reach out today to discuss your medical research consultation needs. We will be reviewing your study goals, your existing data, and the phase your project is currently in, and guide you toward a publication-ready outcome that meets international academic standards.</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
            </div>
          </div>
        </section>
        

        
      </div>
    </>
  );
}